module.exports = __webpack_public_path__ + "static/media/logo.dbf24e8d.svg";